import moment from "moment";

export function validEarningLoyalityRoles(LoyalityRoles) {
  let nowDate = moment().utc();
  let validLoyalityRoles = LoyalityRoles.filter(
    pt =>
      !pt.Disable &&
      moment(pt.ExpiredDate.seconds * 1000)
        .utc()
        .isAfter(nowDate)
  );
  return validLoyalityRoles;
}
